import { Dictionary } from '@reduxjs/toolkit'
import omit from 'lodash/fp/omit'
import { window } from '@mtsbank/ui-kit'
import { SPA_SBP_PATH, SPA_SBP_RESULT_PATH } from '@root/constants'

import { statDataLoader } from './StatDataLoader'

// import { store as reduxStore } from '@store/index'

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[]
    // dataLayer: Array<unknown>
  }
}

export const emptyEvent = {
  event: null,
  eventCategory: null,
  eventAction: null,
  eventLabel: null,
  eventValue: null,
  userId: null,
  guId: null,
  userAuth: null,
  abonent: null,
  screenName: null,
  eventContent: null,
  eventContext: null,
  buttonLocation: null,
  filterName: null,
  pageType: null,
  actionGroup: null,
  productName: null,
  productId: null,
  numberType: null,
  accountType: null,
  grclientId: null,
  touchPoint: 'web',
  bannerName: null,
  bannerId: null,
  regionId: null,
  region: null,
  em: null,
  CD1: null,
  ref: null,
}

const emptyEventNCPK = {
  event: null,
  eventCategory: null,
  eventAction: null,
  eventLabel: null,
  eventValue: null,
  userId: null,
  grclientId: null,
  grId: null,
  userAuth: null,
  abonent: null,
  screenName: null,
  eventContent: null,
  eventContext: null,
  buttonLocation: null,
  filterName: null,
  pageType: null,
  actionGroup: null,
  productName: null,
  productId: null,
  numberType: null,
  accountType: null,
  touchPoint: 'web',
  bannerName: null,
  bannerId: null,
  regionId: null,
  region: null,
}

export type EventType = Partial<typeof emptyEvent>

export const events = {
  mtsLogin: 'mtsLogin',
  mtsGosU: 'mtsGosU',
  mtsEvent: 'mtsEvent',
  mtsPageview: 'mtsPageview',
  mtsAdv: 'mtsAdv',
  mtsChek: 'mtsChek',
  mtsNcpk: 'mtsNcpk',
  mtsSchet: 'mtsSchet',
  mtsSpaCyber: 'mtsSpaCyber',

  vntMain: 'vntMain',
  vntVsego: 'vntVsego',
  vntKosh: 'vntKosh',
  vntIzbr: 'vntIzbr',
  vntTelef: 'vntTelef',
  vntCash: 'vntCash',
  vntKart: 'vntKart',
  vntKred: 'vntKred',
  vntVklad: 'vntVklad',
  vntSchet: 'vntSchet',
  vntShabl: 'vntShabl',

  mtsCross: 'mtsCross',
  mtsPaymentSpa: 'mtsPaymentSpa',
} as const

export const eventCategories = {
  avtorizaciya: 'avtorizaciya',
  faq: 'faq',
  app: 'app',

  shablonyIAvtoplatezhy: 'shablony_i_avtoplatezhy',
  scheta: 'scheta',
  vklady: 'vklady',
  kredity: 'kredity',
  karty: 'karty',
  mtsCashback: 'mts_cashback',
  moiTelefon: 'moi_telefon',
  izbrannoe: 'izbrannoe',
  moiKoshelek: 'moi_koshelek',
  vsegoSredstv: 'vsego_sredstv',
  main: 'main',
  platezhi: 'platezhi',
  chek: 'chek',
  advertising: 'advertising',
  perevody: 'perevody',
  error: 'error',
  ncpkForma: 'ncpk_forma',

  glavnayaPaymentsMenu: 'glavnaya_payments_menu',
  glavnayaPaymentsVypodauscheeMenu: 'glavnaya_payments_vypodauschee_menu',
  glavnayaPayments: 'glavnaya_payments',

  glavnayaPaymentsAz: 'glavnaya_payments_az',
  glavnayaVidzhetMneOdobreno: 'glavnaya_vidzhet_mne_odobreno',
  glavnayaVidzhetMoiTelefon: 'glavnaya_vidzhet_moi_telefon',
  glavnayaVidzhetKarty: 'glavnaya_vidzhet_karty',
  glavnayaVidzhetScheta: 'glavnaya_vidzhet_scheta',
  glavnayaVidzhetKredity: 'glavnaya_vidzhet_kredity',
  glavnayaVidzhetVklady: 'glavnaya_vidzhet_vklady',

  igrovaya_stranica: 'igrovaya_stranica',
} as const

export const eventActions = {
  buttonClick: 'button_click',
  buttonShow: 'button_show',
  buttonView: 'button_view',
  linkClick: 'link_click',
  elementClick: 'element_click',
  appClick: 'app_click',

  switcherSwitch: 'switcher_switch',
  elementChange: 'element_change',
  elementFailed: 'element_failed',

  popupShow: 'popup_show',
  cardClick: 'card_click',
  elementShow: 'element_show',
  elementView: 'element_view',

  bannerShow: 'banner_show',
  bannerView: 'banner_view',
  bannerClick: 'banner_click',

  formShow: 'form_show',
  errorShow: 'error_show',
  confirmed: 'confirmed',
  rejected: 'rejected',
  screenShow: 'screen_show',
  formAdd: 'form_add',
  elementStatus: 'element_status',
  reject: 'reject',
  confirm: 'confirm',
  formConfirm: 'form_confirmed',
  formRejected: 'form_rejected',
} as const

export const cardStatuses = {
  kartaZablokirovana: 'karta_zablokirovana ',
  kartaNaPerevypuske: 'karta_na_perevypuske ',
  kartaZakryta: 'karta_zakryta ',
  novayaKartaGotova: 'novaya_karta_gotova',
} as const

export type cardStatusesTypes = typeof cardStatuses[keyof typeof cardStatuses]

export const TemplatesAndAutoPaymentsButtons = {
  sablony: 'sablony',
  avtoplatezhy: 'avtoplatezhy',
  schetaNaOplatu: 'scheta_na_oplatu',
} as const

export type TemplatesAndAutoPaymentsButtonTypes =
  typeof TemplatesAndAutoPaymentsButtons[keyof typeof TemplatesAndAutoPaymentsButtons]

export enum StoreMarkets {
  AppStore = 'APP_STORE',
  GooglePlay = 'google_play',
  AppGallery = 'app_gallery',
}

export const eventLabels = {
  voiti: 'voiti',
  vopros: 'vopros',
  mts: 'mtsbank_ru',
  appStore: StoreMarkets.AppStore,
  googlePlay: StoreMarkets.GooglePlay,
  appGallery: StoreMarkets.AppGallery,

  perevodyIPlatezhi: 'perevody_i_platezhi',
  pokazat: 'pokazat',
  skryt: 'skryt',
  oshibkaZagruzkiBalansa: 'oshibka_zagruzki_balansa',
  oshibka: 'oshibka',
  popolnit: 'popolnit',
  cashback: 'cashback',
  perezagruzit: 'perezagruzit',
  otkrytNovyiProdukt: 'otkryt_novyi_produkt',

  popolnenieScheta: 'popolnenie_scheta',
  dalee: 'dalee',
  nomerTelefona: 'nomer_telefona',
  nomerLicevogoScheta: 'nomer_licevogo_scheta',
  nomerKarty: 'nomer_karty',
  srokDeistviyaKarty: 'srok_deistviya',
  cvv: 'cvv',
  summaPlatezha: 'summa_platezha',
  podskazka: 'podskazka',
  sposobOplaty: 'sposob_oplaty',

  oplatit: 'oplatit',
  oplata: 'oplata',

  akciya: 'akciya',
  perezagruzka: 'perezagruzka',
  checkbox: 'checkbox',
  email: 'email',
  oshibkaZagruzki: 'oshibka_zagruzki',
  oformitKartu: 'oformit_kartu',
  naGlavnuu: 'na_glavnuu',
  uspeshnyiPerevod: 'uspeshnyi_perevod',
  prodolzhit: 'prodolzhit',
  proverkaDannyh: 'proverka_dannyh',
  sbp: 'sbp',
  spisatS: 'spisat_s',
  ochistit: 'ochistit',
  otdeleniyaNaKarte: 'otdeleniya_na_karte',
  zakryt: 'zakryt',
  perevestiPoKarte: 'perevesti_po_karte',
  povtorit: 'povtorit',
  perevesti: 'perevesti',
  stikery: 'stikery',
  // for ncpk
  issueDone: 'kredit_uspeshno_oformlen',
  resendSmsCode: 'vyslat_sms_kod_povtorno',
  smsCode: 'sms_kod',
  signСontract: 'podpisat_dogovor',
  condition: 'usloviyami',
  sendDocsToEmail: 'otpravit_dogovor_na_pochtu',
  sumInfo: 'informaciya_o_summe_na_ruki',
  downloadPDFLoan: 'skachat_dogovor_kreditovaniya_v_pdf',
  downloadPFDInsurance: 'skachat_dogovor_strahovaniya_v_pdf',
  cancelIssue: 'otmenit_zayavku',
  prepareDocs: 'podgotovit_dokumenty',
  issueSend: 'zayavka_na_kredit_otpravlena',
  stories: 'gotovim_dokumenty_po_kreditu',
  refinReason: 'prichina_refinansirovaniya',
  otherReason: 'ukazhite_cel',
  faForma: 'ncpk_fa_forma',
  payDay: 'data_platezha',
  ncpkForma: 'ncpk_forma',
  sumСredit: 'summa_kredita',
  rasschitat_kredit: 'rasschitat_kredit',
  termCredit: 'srok_kredita',
  goalCredit: 'cel_kredita',
  krestik: 'krestik',
  averageMonthly: 'srednemesyachnyi_dohod',
  ncpk_fa_froma: 'ncpk_fa_froma',
  fio: 'familiya_imya_otchetsvo',
  birthday: 'data_rozhdeniya',
  calendar: 'kalendar',
  gender: 'pol',
  checkPersData: 'usloviya_obrabotki_personalnyh_dannyh',
  checkPFR: 'ya_dau_svoe_soglasie_na_zapros_moei_vypiski_individualnogo_licevogo_scheta_v_pfr',
  checkSms: 'ya_dau_svoe_soglasie_na_uvedomlenie_o_specpredlozheniyah_po_sms_i_drugim_kanalam',
  checkCreditHistory: 'razreshau_banku_proverit_mou_kreditnuu_istoriu',
  nazad: 'nazad',
  passport: 'seriya_i_nomer_pasporta',
  dataIssue: 'data_vydachi_pasporta',
  kodDepartment: 'kod_podrazdeleniya',
  kemVydan: 'kem_vydan',
  adressReg: 'adres_registracii',
  matchesAdress: 'adres_prozhivaniya_sovpadaet_s_adresom_registracii',
  adressFact: 'adres_fakticheskogo_prozhivaniya',
  codeWord: 'kodovoe_slovo',
  publicFace: 'ya_imeu_otnoshenie_k_publichnomu_dolzhnostnomu_licu',
  checkboxUSA: 'ya_nalogoplatelschik_ssha',
  resident: 'ya_inostrannyi_nalogovyi_rezident',
  workActivity: 'vid_zanyatosti',
  experienceWork: 'god_nachala_trudovogo_stazha',
  nameOrganization: 'nazvanie_organizacii',
  innOrganization: 'inn_organizacii',
  level: 'uroven_dolzhnosti',
  namePosition: 'polnoe_nazvanie_dolzhnosti',
  adressOrganization: 'adres_organizacii',
  startWork: 'data_priema_na_rabotu',
  phoneWork: 'rabochii_telefon',
  education: 'obrazovanie',
  familyStatus: 'semeinoe_polozhenie',
  dependents: 'kolichestvo_chelovek_na_izhdivenii',
  sendForm: 'otpravit_zayavku',
  contractCredit: 'dogovor_kreditovaniya',
  nopurposeLoan: 'necelevoi_kredit',
  serviceError: 'servis_vremenno_nedostupen',

  clickNaChastnimKlientam: 'click_na_chastnim_klientam',
  clickNaBisnesu: 'click_na_bisnesu',
  clickNaVseSaity: 'click_na_vse_saity',
  clickNaGoszakazchikam: 'click_na_goszakazchikam',
  clickNaOKompanii: 'click_na_o_kompanii',
  clickNaPostavschkam: 'click_na_postavschkam',
  clickNaMtsMedia: 'click_na_mts_media',
  clickNaInvestorRelations: 'click_na_investor_relations',
  clickNaMtsBankLogo: 'click_na_mts_bank_logo',
  clickNaMtsGlavnaya: 'click_na_mts_glavnaya',
  clickNaMtsGlavnayaNavBar: 'click_na_mts_glavnaya_navbar',

  otkrylGlavnayaPaymentsAz: 'otkryl_glavnaya_payments_az',
  clickNaNomerProfilya: 'click_na_nomer_profilya',
  clickNaMobSvyaz: 'click_na_mob_svyaz',
  clickNaProfile: 'click_na_profile',
  clickNaVyhod: 'click_na_vyhod',
  clickNaMtsAvtoplatezhi: 'click_na_mts_avtoplatezhi',
  clickNaMtsPlatezhi: 'click_na_mts_platezhi',
  clickNaMtsPlatezhiNavBar: 'click_na_mts_platezhi_navbar',
  clickNaMtsIstoriya: 'click_na_mts_istoriya',
  clickNaMtsIstoriyaNavBar: 'click_na_mts_istoriya_navbar',
  clickNaMtsBankovskieProducty: 'click_na_mts_bankovskie_producty',
  mneOdobreno: 'mne_odobreno',
  moiTelefon: 'moi_telefon',
  bannerShow: 'banner_show',
  bannerProsmotr: 'banner_prosmotr',
  clickNaBanner: 'click_na_banner',
  kartyVidzhetShow: 'karty_vidzhet_show',
  kartyVidzhetProsmotr: 'karty_vidzhet_prosmotr',
  clickNaKartyVidzhet: 'click_na_karty_vidzhet',
  schetaVidzhetShow: 'scheta_vidzhet_show',
  schetaVidzhetProsmotr: 'scheta_vidzhet_prosmotr',
  clickNaSchetaVidzhet: 'click_na_scheta_vidzhet',
  kredityVidzhetShow: 'kredity_vidzhet_show',
  kredityVidzhetProsmotr: 'kredity_vidzhet_prosmotr',
  clickNaKredityVidzhet: 'click_na_kredity_vidzhet',
  vkladyVidzhetShow: 'vklady_vidzhet_show',
  vkladyVidzhetProsmotr: 'vklady_vidzhet_prosmotr',
  clickNaVkladyVidzhet: 'click_na_vklady_vidzhet',
  noviyProductButtonShow: 'noviy_product_button_show',
  noviyProductButtonProsmotr: 'noviy_product_button_prosmotr',
  clickNaNoviyProductButton: 'click_na_noviy_product_button',
  recomendaciiVidzhetShow: 'recomendacii_vidzhet_show',
  recomendaciiVidzhetProsmotr: 'recomendacii_vidzhet_prosmotr',
  clickNaRecomendaciiVidzhet: 'click_na_recomendacii_vidzhet',
  shablonyAvtoplatezhiVidzhetShow: 'shablony_avtoplatezhi_vidzhet_show',
  shablonyAvtoplatezhiVidzhetProsmotr: 'shablony_avtoplatezhi_vidzhet_prosmotr',
  clickNaSchetNaOplatyVidzhet: 'click_na_schet_na_oplaty_vidzhet',
  clickNaShablonyVidzhet: 'click_na_shablony_vidzhet',
  clickNaAvtoplatezhiVidzhet: 'click_na_avtoplatezhi_vidzhet',
  clickNaSozdatNoviyVidzhet: 'click_na_sozdat_noviy_vidzhet',
  keshbekAkciiVidzhet: 'keshbek_akcii_vidzhet',
  keshbekAkciiVidzhetCashback: 'keshbek_akcii_vidzhet_cashback',
  escheVidzhet: 'esche_vidzhet',
  escheVidzhetProsmotr: 'esche_vidzhet_prosmotr',
  clickNaIstoriyaOperaciyVidzhet: 'click_na_istoriya_operaciy_vidzhet',
  clickNaKomisiiILimityVidzhet: 'click_na_komisii_i_limity_vidzhet',
  clickNaSpravkiIVypiskiVidzhet: 'click_na_spravki_i_vypiski_vidzhet',
  clickNaOficyIAtmVidzhet: 'click_na_oficy_i_atm_vidzhet',

  // for cyber
  otkrylGlavnayaCyber: 'otkryl_glavnaya_cyber',
  login: 'login_mail',
  sum: 'sum',
  clickNaVaucher: 'klik_na_vaucher',
  kodKarty: 'kod_karty',
  platezhVobrabotke: 'platezh_v_obrabotke',
  kupit: 'kupit',
  platezhOtpravlen: 'platezh_otpravlen',
  platezhNeOtpravlen: 'platezh_ne_otpravlen',
  nedostatochnoSredstv: 'nedostatochno_sredstv',
  podrobnee: 'podrobnee',
  rekvizity: 'rekvizity',
  bannerMain: 'banner_main',
  bannerFinal: 'banner_final',
  searchFormAdd: 'search_form_add',
  serviceSearchForm: 'service_search_form',
  servicePopular: 'service_popular',
  serviceCatalog: 'service_catalog',
  categoryChange: 'category_change',
  newsClick: 'news_click',
  loginMailError: 'login_mail_error',
  region: 'region',
  toMainPage: 'to_main_page',
  glavnaya: 'glavnaya',
  glavnayaError: 'glavnaya_error',
  final: 'final',
  news: 'news_page',
  prinyatUchastie: 'prinyat_uchastie',
  uchastnikRozigrisha: 'uchastnik_rozigrisha',
  popolnitAkkaunt: 'popolnit_akkaunt',
  promoInarius: 'promo_inarius',
  pravilaAkciiKeshbekZaIgry: 'pravila_akcii_keshbek_za_igry',
  vidzhetKeshbek30: 'vidzhet_keshbek_30',
  individZakaz: 'individ_zakaz',
} as const

export type EventLabelsType = typeof eventLabels

export const screenNames = {
  gosuslugiInfo: '/spa/gosuslugi-info', // Страница Госуслуги не выходя из дома
  newMain: '/spa', // Новая главная

  // pay services
  payPhone: '/spa/pay/phone',
  payServiceId: (serviceId: string) => `/spa/pay/${serviceId}`,
  payResult: '/spa/pay/result',
  transferSBP: '/spa/transfer/sbp',

  /** Страница МТС Счет */
  accountsOpen: '/spa/accountsopen',
  accountsOpenOrder: (order: string) => `/spa/accountsopen/order/${order}`,

  // cyber
  cyber: '/cyber',
} as const

type ScreenNamesTypes = typeof screenNames
export type ScreenNamesValues = ScreenNamesTypes[keyof ScreenNamesTypes]

// todo screenNames по хорошему в константы вынести, а pageConfig в конфиг
export const pageConfig = {
  [SPA_SBP_RESULT_PATH]: {
    screenName: screenNames.transferSBP,
    pageType: screenNames.transferSBP,
  },
  [SPA_SBP_PATH]: {
    screenName: screenNames.transferSBP,
    pageType: screenNames.transferSBP,
  },
  [screenNames.gosuslugiInfo]: {
    screenName: screenNames.gosuslugiInfo,
    pageType: screenNames.gosuslugiInfo,
  },
}

export const eventContents = {
  banner: 'banner',
  vLichnomKabinete: 'v_lichnom_kabinete',
  bezAvtorizacii: 'bez_avtorizacii',
  mneNuzhenFiskalnyiChek: 'mne_nuzhen_fiskalnyi_chek',
  spisatS: 'spisat_s',
  polzunok: 'polzunok',
  step1: 'step_1',
  vruchnuu: 'vruchnuu',
  celKredita: 'cel_kredita',
  step2: 'step_2',
  dataRozhdeniya: 'data_rozhdeniya',
  step3: 'step_3',
  dataVydachiPasporta: 'data_vydachi_pasporta',
  step4: 'step_4',
  vidZanyatosti: 'vid_zanyatosti',
  urovenDolzhnosti: 'uroven_dolzhnosti',
  obrazovanie: 'obrazovanie',
  semeinoePolozhenie: 'semeinoe_polozhenie',
  osnovnayaStranica: 'osnovnaya_stranica',
  uspehSBP: 'uspeh_SBP',
} as const

export const eventContexts = {
  mtsMoney: 'mts_dengi',
  otkrytSchet: 'otkryt_schet',
  oformiteZayavkuNaKredit: 'oformite_zayavku_na_kredit',
  SBP: 'sbp',
  MTS: 'mts',
  cardMTS: 'karta_MTS_bank',
  nachniIgru: 'nachni_igru',
  promoInarius: 'promo_inarius',
  popUpPromoInarius: 'pop_up_promo_inarius',
} as const

export const buttonLocations = {
  footer: 'footer',
  header: 'header',
} as const

export const actionGroups = {
  interactions: 'interactions',
  nonInteractions: 'non_interactions',
  conversions: 'conversions',
} as const

export function sendGmtEvent(event: { [K in keyof typeof emptyEvent]?: string | null }, pagesEvent?: boolean) {
  // const { userData } = authHelper

  if (!window.dataLayer) {
    window.dataLayer = []
  }

  const baseEvent = pagesEvent
    ? omit(['eventCategory', 'eventAction', 'eventLabel', 'eventValue'], emptyEvent)
    : emptyEvent

  window.dataLayer.push({
    ...baseEvent,
    // userAuth: authHelper.isAuthenticated() ? '1' : '0',
    // ...(userProfile?.mobilePhone && { ph: md5(userProfile?.mobilePhone) }),
    // ...(userData?.rbo_id && { grclientId: userData.rbo_id }),

    ...event,
  })
}

type ScreenNamesKeys = keyof typeof screenNames

export function gtmPagesEvents(event?: { [K in keyof typeof emptyEvent]?: string | null }): {
  [K in ScreenNamesKeys]: (args?) => void
} {
  const keys = Object.keys(screenNames) as Array<ScreenNamesKeys>

  return keys.reduce(
    (acc, page: ScreenNamesKeys) => ({
      ...acc,
      [page]: (...args) => {
        sendGmtEvent(
          {
            event: events.mtsPageview,
            screenName:
              typeof screenNames[page] === 'function'
                ? (screenNames[page] as (args) => string)(args)
                : (screenNames[page] as string),
            actionGroup: actionGroups.nonInteractions,
            ...event,
          },
          true
        )
      },
    }),
    {} as { [K in ScreenNamesKeys]: (args?) => void }
  )
}

/** Отправлям только то что прописанно в pageConfig для осознанного встраивания разметки */
export const sendGmtEventPerPage = (
  eventOptions: { [K in keyof typeof emptyEvent]?: string | null },
  pagesEvent?: boolean,
  pathname?: string
) => {
  const path = pathname ?? window.location.pathname
  const pageParams: Dictionary<Dictionary<string>> = pageConfig[path]

  if (pageParams) {
    statDataLoader.push((event: EventType) =>
      sendGmtEvent(
        {
          ...event,
          ...pageParams,
          ...eventOptions,
        },
        pagesEvent
      )
    )
  }
}

export function sendGmtNCPKEvent(event: { [K in keyof typeof emptyEventNCPK]?: string | null }, pagesEvent?: boolean) {
  if (!window.dataLayer) {
    window.dataLayer = []
  }

  const baseEvent = pagesEvent
    ? omit(['eventCategory', 'eventAction', 'eventLabel', 'eventValue'], emptyEventNCPK)
    : emptyEventNCPK

  // may be store.auth.isAuthenticated ? 1 : 0
  window.dataLayer.push({ ...baseEvent, userAuth: localStorage.getItem('access_token_cyber') ? '1' : '0', ...event })
}
